// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Priorities_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/priorities/lista
 *
 * List of active priorities. Wire shape: `dados: Priorities_PriorityRow[]`
 * — the list is emitted directly as `dados`, not nested under a key.
 */
import type { Priorities_PriorityRow } from './Priorities_PriorityRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Priorities_ListaResponseDados = Priorities_PriorityRow[];

export type Priorities_ListaResponse = ApiResponse<Priorities_ListaResponseDados>;

registerResponseContract('Priorities_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_priority_id:           { type: 'number',  required: true },
      so_priority_name:         { type: 'string',  required: true },
      so_priority_franchise_id: { type: 'number',  required: true },
      so_priority_active:       { type: 'number',  required: true },
      so_priority_color:        { type: 'string',  required: false },
      so_priority_created_at:   { type: 'string',  required: false },
    },
  },
})
